import {
    PRESUPUESTADOR_DISABLE_BTN_SAVE,
} from '../constants';


export function setDisableBtnSave() {
    return (dispatch) => {
        dispatch({
            type: PRESUPUESTADOR_DISABLE_BTN_SAVE
        })
    }
}